(function () {

	const footer = () => {
		const footerDetails = document.querySelectorAll(
			'.footer .accordion details',
		);
		footerDetails.forEach((targetDetail) => {
			targetDetail.addEventListener('click', () => {
				footerDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				});
			});
		});

	}

	document.addEventListener('shopify:section:load', footer);
	footer();

})();

// custom code for appending html table for faq page last menu of faq collapse
// Select the span element
var encodedHtml = $('.metafield-multi_line_text_field').html();

// Decode the HTML entities
var decodedHtml = $('<div/>').html(encodedHtml).text();

// Replace the encoded content with the decoded HTML
$('.metafield-multi_line_text_field').html(decodedHtml);